import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '@portal-front/portal-auth-ui';
import { ToastWrapperComponent } from '@portal-front/design-system-angular';
import { REFERER, refererFactory } from '@portal-front/portal-auth-util-urls';

@Component({
  selector: 'ef-auth-feature-shell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavbarComponent, RouterOutlet, ToastWrapperComponent],
  providers: [
    {
      provide: REFERER,
      useFactory: refererFactory,
    },
  ],
  templateUrl: './portal-auth-feature-shell.component.html',
  styleUrl: './portal-auth-feature-shell.component.css',
})
export class PortalAuthFeatureShellComponent implements OnInit {
  public async ngOnInit(): Promise<void> {
    const init = function () {
      const onDecline = () => {
        window.location.reload();
      };

      window.addEventListener('CookiebotOnDialogDisplay', () => {
        // event CookiebotOnDecline jest emitowany nawet na pierwsze wejscie na strone, niezaleznie czy user to kliknal na modalu,
        // wiec zabezpieczylem, zeby callback wykonal sie tylko, kiedy user wykona decline
        window.addEventListener('CookiebotOnDecline', onDecline);
      });
    };

    if (typeof window.Cookiebot !== 'undefined') {
      init();
    } else {
      window.addEventListener('CookiebotOnLoad', init);
    }
  }
}
